import ApiLibrary from "./ApiLibrary";

class Engagement extends ApiLibrary.Base {
  static className = "Engagement";

  static define() {}

  salary = () => {
    if (this.isContract) {
      return `${this.salaryMin}/day`;
    }
    if (this.salaryType === "range" && this.salaryMax) {
      return `${this.salaryMin} - ${this.salaryMax}`;
    }
    return this.salaryMin;
  };
}

export default ApiLibrary.createResource(Engagement);
